import { createSelector } from "@reduxjs/toolkit";

export const selectDecksState = (state) => state.decks;

export const selectDecks = (state) => selectDecksState(state).decks;

export const selectSelectedIndex = (state) => selectDecksState(state).selectedIndex;

export const selectSelectedDeck = createSelector([selectDecks, selectSelectedIndex], (decks, selectedIndex) => decks[selectedIndex]);
